module.exports = __webpack_public_path__ + "static/media/SpringVille_PH2_2.a60739e0.webp";